import 'core-js/stable'
import Vue from 'vue'
import router from './router'
import store from './store/index'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import config from '@/config'
import importDirective from '@/directive'
import './utils/directives'

// import {
//   routeData
// } from '@/assets/dataFormat/routeData'
import {
  getLoginUser,
} from '@/api/request'
// 按需引入 echarts 5.x
import echarts from './plugins/echartsUI'
Vue.prototype.$echarts = echarts


Vue.use(ElementUI)
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
importDirective(Vue)
// if( process.env.NODE_ENV === "development"){
//   config.user.role = { type: 0, name: 'jinpanpan' }
//   /* eslint-disable no-new */
//   new Vue({
//     el: '#app',
//     router,
//     store,
//     render: h => h(App)
//   })
// }else{

if (config.version == "h5") {
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  })


  let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"))
  if(router.currentRoute.path === "/reportDetails") {
    router.push(router.currentRoute.fullPath)
  } else if (router.currentRoute.path === "/eventDetails") {
    router.push(router.currentRoute.fullPath)
  } else if (!userInfo) {
    router.push('/login')
  } else {
    store.dispatch('getDynamicMenuRoutes', userInfo)
    store.state.permission.addRouters.forEach(r => router.addRouteNotAdded(r))
    if (!window.location.href||window.location.href=='#/') {
      router.push("/" +store.state.permission.defaultRoute)
    }
    router.beforeEach((to, from, next) => {
      if (to.path == "/" && store.state.permission.defaultRoute) {
        next(store.state.permission.defaultRoute)
      } else {
        next()
      }
    })
  }
} else {
  getLoginUser().then(res => {
    if (res.success) {
      store.dispatch('getDynamicMenuRoutes', res.data)
      store.state.permission.addRouters.forEach(r => router.addRouteNotAdded(r))
      router.beforeEach((to, from, next) => {
        if (to.path == "/" && store.state.permission.defaultRoute) {
          next(store.state.permission.defaultRoute)
        } else {
          next()
        }
      })
      new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App)
      })
    }
  })
}


// const VUE_APP_VERSION = require('../package.json').version
// const vers = window.localStorage.getItem("appVersion");
// console.log(VUE_APP_VERSION)
// console.log(vers)
// if(VUE_APP_VERSION != vers){
//   localStorage.clear()
//   window.localStorage.setItem("appVersion", VUE_APP_VERSION);
//   location.reload(true)
// }
